import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Carousel from "../../../utilerias/carousel";
import Galeria from "../../../utilerias/galeria.json";
import "./styles.css";

const CarouselComponent = (props) => {
  return (
    <Fragment>
      <Carousel componente={props.componente} imagenes={Galeria}></Carousel>
    </Fragment>
  );
};

CarouselComponent.propTypes = {
  componente: PropTypes.string,
};

export default CarouselComponent;
